import React from 'react';

const History = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className=" mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 font-georgian mb-4">
            გუნდის ისტორია
          </h1>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          {/* Center Logo */}
          <div className="flex justify-center mb-8">
            <img 
              src="/iveria.png" 
              alt="ივერია ლოგო" 
              className="h-32 sm:h-40 lg:h-48 w-auto object-contain"
            />
        </div>

          {/* Content with Side Logos */}
          <div className="flex items-start space-x-8 lg:space-x-12">
            {/* Old Logo - Left */}
            <div className="flex-shrink-0 hidden md:block">
              <img 
                src="/old.jpg" 
                alt="ძველი ლოგო" 
                className="h-40 lg:h-48 xl:h-56 w-auto object-contain"
              />
                </div>
            
            {/* Main Text Content */}
            <div className="flex-1 prose prose-lg max-w-none">
            <p className="text-gray-700 font-georgian leading-relaxed text-justify">
              ხაშური, ფოთთან და თბილისთან ერთად, შეიძლება თამამად ჩაითვალოს ქართული ფეხბურთის მექად. ყველაფერი კი გასული საუკუნის ათიანი წლებიდან დაიწყო, როდესაც იმ დროისთვის სპორტის სრულიად უცხო სახეობა ხაშურში შოტლანდიელებმა შემოიტანეს. შოტლანდიური გარნიზონი 1904 წელს ხაშურში შემოვიდა და რამდენიმე წელი ამ ქალაქში დარჩა. ჯარისკაცები გარნიზონის ეზოში, დასვენების პერიოდში ხშირად ერთობოდნენ ფეხბურთით. ამ თამაშით ხაშურელი მოზარდებიც დაინტერესდნენ, რომლებმაც ისე სწრაფად აითვისეს ეს სიახლე რომ 1918 წელს, საქართველოს ისტორიაში ერთ-ერთი პირველი „საერთაშორისო" მატჩი სწორედ ხაშურში გაიმართა, რომელშიც ერთმანეთს შოტლანდიისა და ხაშურის „ნაკრებები" შეხვდნენ.
            </p>
            
            <p className="text-gray-700 font-georgian leading-relaxed text-justify mt-6">
              ქვეყნის გასაბჭოების შემდეგ, 1923-24 წლებიდან, ფეხბურთი იმდენად პოპულარული გახდა ამ ქალაქში, რომ უკვე 3 გუნდიც კი არსებობდა: „ორბი", „პატარა კახი" და „ჭალა". შემდეგ კი ამ 3 გუნდის ბაზაზე შეიქმნა რაიონის ნაკრები, რომლის მემკვიდრეც არის სწორედ დღევანდელი „ივერია". ამ ნაკრებს ხშირად ჰქონდა თამაშები გამოცდილ და ძლიერ გუნდებთან. ერთ-ერთი მათგანი იყო ბაქოს გუნდთან თამაში, რომელიც ხაშურელების გამარჯვებით დასრულდა. პარალელურად ხშირი იყო მატჩები ბორჯომის, ზესტაფონის, სამტრედიის, ფოთის, ჭიათურის, განჯის, გორის და თბილისის გუნდებთან. გუნდს, სანამ „ივერიის" სახელწოდებას მიიღებდა, ხშირად ეცვლებოდა სახელი: „რკინიგზელი", „ლოკომოტივი", „ზემო ქართლი"...
            </p>
            
            <p className="text-gray-700 font-georgian leading-relaxed text-justify mt-6">
              30-იანი წლების ბოლოდან ეს გუნდი საქართველოს პირველობაზეც წარმატებით იბრძვის. 1946 წელს ამიერკავკასიის რკინიგზის თასიც მოიპოვეს. ამავე წელს კი საქართველოს პირველობაზე მეორე ადგილზე გავიდნენ და მხოლოდ ქუთაისის „ტორპედოს" ჩამორჩნენ. სხვათა შორის, ზემოაღნიშნული თასი ხაშურის გუნდმა ზედიზედ სამჯერ მოიგო.
            </p>
            
            <p className="text-gray-700 font-georgian leading-relaxed text-justify mt-6">
              1949 წელს გუნდს უკვე საკუთარი სტადიონი ჰქონდა. მის აშენებაში მთელი რაიონის მოსახლეობა იყო ჩართული და იმ პერიოდისთვის მშვენიერი სტადიონიც აიგო. გუნდი რეგულარულად იღებს მონაწილეობას საქართველოს პირველობაზე (მეორე ლიგა). 1970 წელს გუნდს სახელი შეეცვალა და დღემდე „ივერია"-ს სახელით ასპარეზობს. სწორედ ამ წელს „ივერიამ" გადამწყვეტ ფინალში ხობის „კოლხეთი" დაამარცხა და პირველ ლიგაში თამაშის უფლება მოიპოვა.
            </p>
            
            <p className="text-gray-700 font-georgian leading-relaxed text-justify mt-6">
              1990 წლამდე, სანამ ფეხბურთის ფედერაცია საკავშირო ფედერაციას გამოეყოფოდა, „ივერია"-ს წარმატებული სეზონი იყო 1973 წელი, როდესაც გუნდმა საქართველოს თასის ფინალში ითამაშა. ასევე, მათი მხრიდან დიდი წარმატება იყო საკავშირო ტურნირის „მეგობრობის" თასის ორჯერ მოგება (1981, 1984 წ.წ). ამ ტურნირში თითქმის ყველა მოკავშირე რესპუბლიკის გუნდი მონაწილეობდა. ტურნირი უკრაინაში იმართებოდა და ორგანიზებას საკავშირო სპორტული საზოგადოება „ოქროს თავთავი" უწევდა. 1981 წელს მათ ფინალში უკრაინელები დაამარცხეს (მანამდე კი ბელორუსიის, სომხეთის და ესტონეთის გუნდები), ხოლო 1984 წელს ფინალი კვლავ უკრაინელებს მოუგეს.
            </p>
            
            <p className="text-gray-700 font-georgian leading-relaxed text-justify mt-6">
              1990 წლიდან იწყება დამოუკიდებელი საქართველოს პირველი ჩემპიონატი ფეხბურთში, რომელშიც „ივერიაც" ჩაერთო. (წინა წელს მე-5 ადგილი მოიპოვა საქართველოს ჩემპიონატში და საქართველოს ფეხბურთის ფედერაციის გადაწყვეტილებით, უმაღლეს ლიგაში საკავშირო პირველობაზე მონაწილე გუნდებთან ერთად, სწორედ ზემოაღნიშნული ჩემპიონატის პირველი ხუთ გუნდში მოხვდა, რომელშიც 1996 წლამდე გადმოდიოდა. შემდეგ წლებში ქვეყანაში არსებული მძიმე ეკონომიკური მდგომარეობა უარყოფითად იმოქმედა გუნდზეც და დღეს „ივერია" მეოთხე ლიგაში ასპარეზობს, თუმცა ამჟამად გუნდში არსებული მდგომარეობა (თანამედროვე სტადიონი, რომელიც 2022 წელს შევიდა ექსპლუატაციაში, მყარი ფინანსური გარანტიები) იძლევა იმედს, რომ რამდენიმე წელიწადში „ივერია" დაუბრუნდება ძველ ოჯახს, რომელსაც უმაღლესი ლიგა ეწოდება. დღეს, „ივერიას" მთავარი მიზანი სწორედ ეს არის.
              </p>
            </div>
            
            {/* New Logo - Right */}
            <div className="flex-shrink-0 hidden md:block">
              <img 
                src="/new1.jpg" 
                alt="ახალი ლოგო" 
                className="h-40 lg:h-48 xl:h-56 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;